import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Invoice Notes ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Notes History")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: "sticky-note",
            class: "el-text__warning"
          }),
          _hoisted_1
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.noteValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.noteValue) = $event)),
              rows: 4,
              type: "textarea"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "success",
              onClick: _ctx.saveNote
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "plus-circle" }),
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notesDropdownResponse, (note, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("span", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: "sticky-note",
                class: "el-text__primary"
              }),
              _createTextVNode(" " + _toDisplayString(note.notestoshow), 1)
            ]),
            _createVNode(_component_el_divider)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}